import {
  ArrowLeftOutlined,
  DeleteOutlined,
  PlusOutlined,
} from '@ant-design/icons';

import { Button } from '../../../../components/index';
import { GenericDrawerHeaderContainer } from '../../../../components/common/GenericDrawerHeader/styles';

type StoppagesDrawerHeaderProps = {
  onBack?: () => void;
  onAdd?: () => void;
  onImport?: () => void;
  onDelete?: () => void;
  deleteCount?: number;
  deleteDisabled?: boolean;
};
export function StoppagesDrawerHeader(props: StoppagesDrawerHeaderProps) {
  const {
    onBack,
    onAdd,
    onImport,
    onDelete,
    deleteCount = 0,
    deleteDisabled = true,
  } = props;
  return (
    <GenericDrawerHeaderContainer>
      <div
        style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
      >
        <Button
          type="text"
          icon={
            <ArrowLeftOutlined style={{ color: 'var(--green-sea_dark)' }} />
          }
          onClick={() => (onBack ? onBack() : null)}
          style={{ marginRight: '10px', borderRadius: '25px' }}
        />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <strong style={{ fontSize: '16px' }}>Paralisações</strong>
        </div>
      </div>
      <div style={{ display: 'flex', gap: '10px' }}>
        {onImport && (
          <Button
            size="large"
            type="default"
            icon={<PlusOutlined />}
            onClick={onImport}
          >
            Importar
          </Button>
        )}
        {onDelete && deleteCount > 0 && (
          <Button
            size="large"
            type="default"
            danger
            icon={<DeleteOutlined />}
            onClick={onDelete}
            disabled={deleteDisabled}
          >
            Excluir ({deleteCount})
          </Button>
        )}
        <Button
          size="large"
          type="primary"
          icon={<PlusOutlined />}
          onClick={onAdd}
          // disabled={!hasWorkPeriods}
        >
          Nova paralisação
        </Button>
      </div>
    </GenericDrawerHeaderContainer>
  );
}
